// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2pXt-","error":"Textarea_error__2rlXS","readonly":"Textarea_readonly__3ZNkk","disabled":"Textarea_disabled__27Ua6"};